/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Runs_TitleInputs */

const en_automation_runs_title = /** @type {(inputs: Automation_Runs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runs`)
};

const pt_br2_automation_runs_title = /** @type {(inputs: Automation_Runs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execuções`)
};

/**
* | output |
* | --- |
* | "Runs" |
*
* @param {Automation_Runs_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_runs_title = /** @type {((inputs?: Automation_Runs_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Runs_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_runs_title(inputs)
	return pt_br2_automation_runs_title(inputs)
});